module.exports = __webpack_public_path__ + "img/horizontal_4_1_8019.c54eb348.png";